import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import type { IResponseCustomDomain } from 'entities/ShortLink'

export class UrlShortener extends RowBase<IResponseCustomDomain> {
  constructor(origin: IResponseCustomDomain) {
    super(origin)
    makeObservableRowBase(this)
  }

  get domain() {
    return this.origin.domain
  }

  get status() {
    return this.origin.status
  }

  get fallback_url() {
    return this.origin.fallback_url
  }

  get failed_reason() {
    return this.origin.failed_reason
  }
}
